import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    alert_msg: "",
    alert_type: "",
    alert_loading: false,
}

export const AlertSlice = createSlice({
    name: "AlertSlice",
    initialState,
    reducers: {
        setAlertLoading: (state, action: { payload: boolean }) => {
            state.alert_loading = action.payload
        },
        setAlertFunc: (state, action: { payload: { msg: any; type: string } }) => {
            state.alert_loading = true
            state.alert_msg = action.payload.msg
            state.alert_type = action.payload.type
        },
    },
})

export const { setAlertLoading, setAlertFunc } = AlertSlice.actions

export default AlertSlice.reducer
